export const SkillList = [
  { name: 'JavaScript', percentage: '90' },
  { name: 'C#', percentage: '85' },
  { name: 'SQL', percentage: '90' },
  { name: 'ReactJS', percentage: '95' },
  { name: 'Styled Components', percentage: '95' },
  { name: 'Blazor', percentage: '80' },
  { name: 'C', percentage: '80' },
];
